import { proforientationRecommendationSelectors } from 'portfolio3/features/proforientation/model/selectors';
import { createSelector } from 'reselect';
import { extractDatesFromNestedItems } from 'utils';

export const proforientationRecommendationProforientationYearsSelector = createSelector(
  [proforientationRecommendationSelectors.proforientation],
  (proforientationRecommendationProforientation) =>
    extractDatesFromNestedItems(
      [proforientationRecommendationProforientation],
      [
        {
          type: 'date',
          field: 'unformattedEventDate',
        },
      ],
    ),
);
